import type { SVGProps } from 'react';
const SvgSuitcase = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    height={16}
    fill="none"
    width={16}
    {...props}
  >
    <g
      clipPath="url(#Suitcase_svg__a)"
      strokeLinejoin="round"
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth={1.5}
    >
      <path d="M1.933 4.267h12.134s.933 0 .933.933v8.4s0 .934-.933.934H1.933S1 14.534 1 13.6V5.2s0-.933.933-.933M10.08 2.105a.93.93 0 0 0-.886-.638H6.806a.93.93 0 0 0-.885.638L5.2 4.267h5.6z" />
    </g>
    <defs>
      <clipPath id="Suitcase_svg__a">
        <path d="M0 0h16v16H0z" fill="#fff" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgSuitcase;
